/**
 * Table 增强组件
 *
 * 职责：为文章内容中的 <table> 添加响应式滚动包裹容器
 */

export class Table {
  constructor(private element: HTMLElement) {
    this.wrapTables();
  }

  /**
   * 为所有未包裹的 <table> 添加 overflow-x-auto 容器
   */
  private wrapTables(): void {
    this.element
      .querySelectorAll("table")
      .forEach((table: HTMLTableElement) => {
        if (!table.parentElement?.classList.contains("table-wrapper")) {
          const wrapper = document.createElement("div");
          wrapper.className = "table-wrapper overflow-x-auto";
          table.parentNode?.insertBefore(wrapper, table);
          wrapper.appendChild(table);
        }
      });
  }
}
